"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.databaseFactoryFromCollections = void 0;
const ArrayDatabase_1 = __importDefault(require("./ArrayDatabase"));
const Database_1 = __importDefault(require("./Database"));
const DATABASES_BY_TYPE = {
    map: Database_1.default,
    array: ArrayDatabase_1.default,
};
const databaseFactory = (dbType = 'map') => new DATABASES_BY_TYPE[dbType]();
const databaseFactoryFromCollections = (collections, path) => {
    if (Array.isArray(Object.values(collections)[0]))
        return new ArrayDatabase_1.default(path);
    return new Database_1.default(path);
};
exports.databaseFactoryFromCollections = databaseFactoryFromCollections;
exports.default = databaseFactory;
